export default __webpack_public_path__ + "static/media/done.968a516e.png";